import { theme } from '@theme';

const skipLinkVisibleStyles = {
  position: 'fixed',
  left: '16px',
  top: '16px',
  width: 'auto',
  height: 'auto',
  overflow: 'visible',
  padding: '12px 16px',
  backgroundColor: theme.palette.common.white,
  color: theme.palette.common.primaryDark,
  border: `2px solid ${theme.palette.common.primaryDark}`,
  borderRadius: '4px',
  textDecoration: 'none',
  fontWeight: 600,
  outline: 'none'
} as const;

export const skipToMainContentLink = {
  position: 'absolute',
  left: '-9999px',
  top: 'auto',
  width: '1px',
  height: '1px',
  overflow: 'hidden',
  zIndex: theme.zIndex.tooltip + 1,
  '&:focus:not(:focus-visible)': {
    outline: 'none'
  },
  '&:focus-visible': skipLinkVisibleStyles
};
